import firebaseConfig from '@/config/firebase'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import vuetify from './plugins/vuetify'
import { createPinia } from 'pinia'
import { loadFonts } from './plugins/webfontloader'
import { AVPlugin } from "vue-audio-visual"
import p5vue from "p5vue"

import "@/styles/styles.scss"
import "@/styles/swal.scss"
// Interdit la traduction automatique de l'application (en complément de public/index.html,
// au cas où une librairie modifierait les attributs de <html> ou <body>)
function preventTranslation() {
  for (let element of [document.documentElement, document.body]) {
    if (!element) continue
    element.setAttribute('translate', 'no')
    element.classList.add('notranslate')
  }
}

document.addEventListener("DOMContentLoaded", async () => {
  preventTranslation()
  loadFonts()
  let pinia = createPinia()

  createApp(App)
  .use(pinia)
  .use(router)
  .use(vuetify)
  .use(AVPlugin)
  .use(p5vue)
  .mount('#app')

  preventTranslation()
})
